module.exports = __webpack_public_path__ + "img/MessengerHeader.a0e67356.svg";